import { Component } from '@theme/component';

export class CarouselElop extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.carousel = this.querySelector(".carousel-elop__carousel");
    this.navigation = this.querySelector('.carousel-elop__navigation');
    this.resizeObserver = new ResizeObserver(() => {
      this.#updateNavigation();
    });
    this.resizeObserver.observe(this.carousel);
    this.#updateNavigation();

    const navigation_previous = this.querySelector(".carousel-elop__navigation-previous");
    navigation_previous.addEventListener('click', () => this.#navigatePrevious());

    const navigation_next = this.querySelector(".carousel-elop__navigation-next");
    navigation_next.addEventListener('click', () => this.#navigateNext());
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.resizeObserver?.disconnect();

    const navigation_previous = this.querySelector(".carousel-elop__navigation-previous");
    navigation_previous.removeEventListener('click', () => this.#navigatePrevious());

    const navigation_next = this.querySelector(".carousel-elop__navigation-next");
    navigation_next.removeEventListener('click', () => this.#navigateNext());
  }

  #updateNavigation() {
    const hasOverflow = this.carousel.scrollWidth > this.carousel.clientWidth;
    this.navigation.hidden = !hasOverflow;
  }

  #navigatePrevious() {
    this.carousel.scrollBy({
      left: -200,
      behavior: "smooth"
    });
  }

  #navigateNext() {
    this.carousel.scrollBy({
      left: 200,
      behavior: "smooth"
    });
  }
}

if (!customElements.get('carousel-elop')) {
  customElements.define('carousel-elop', CarouselElop);
}